module.exports = __webpack_public_path__ + "img/UHF-LS-50.6c14a1cd.png";